class ArraySet {
    constructor(array, callbackSetIndex, callbackGetIndex, callbackDeleteIndex) {
        this._array = array;
        this._callbackSetIndex = callbackSetIndex;
        this._callbackGetIndex = callbackGetIndex;
        this._callbackDeleteIndex = callbackDeleteIndex;
    }

    has(value) {
        return this._callbackGetIndex(value) !== null;
    }

    add(value) {
        const oldIndex = this._callbackGetIndex(value);
        if (oldIndex !== null) return;

        const index = this._array.length;
        this._array[index] = value;
        this._callbackSetIndex(value, index);
    }

    delete(value) {
        const index = this._callbackGetIndex(value);
        if (index === null) return;

        const moveValue = this._array[this._array.length-1];
        this._array[index] = moveValue;
        this._callbackSetIndex(moveValue, index);

        this._array.length--;
        this._callbackDeleteIndex(value);
    }
}

export default ArraySet;
